import React from 'react'
import { TickCircle, CloseCircle, Timer, Timer1, Message } from 'iconsax-react'

import MediaAvatar from '../../../../atoms/MediaAvatar'
import OverflowText from '../../../../atoms/OverflowText'

import { getLatestEventDate } from '../../ConversationListV2/helpers'
import { formatTimeSince } from '../../../../../timeUtilities'
import { useUserAPI } from '../../../../../providers/UserAPIProvider'
import { useSocket } from '../../../../../providers/SocketProvider'
import useInterval from '../../../../../hooks/useInterval'
import useStyles from './styles'

const EndedIcon = () => (
  <svg
    width='12'
    height='13'
    viewBox='0 0 12 13'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M9.015 5.25C8.04 5.25 7.25 4.46 7.25 3.485V2C7.25 1.725 7.025 1.5 6.75 1.5H3.5C2.12 1.5 1 2.615 1 3.99V7.475C1 8.855 2.12 9.975 3.5 9.975H4.25C4.39 9.975 4.57 10.065 4.65 10.175L5.4 11.17C5.73 11.61 6.27 11.61 6.6 11.17L7.35 10.175C7.445 10.05 7.595 9.975 7.75 9.975H8.505C9.885 9.975 11 8.86 11 7.48V5.75C11 5.475 10.775 5.25 10.5 5.25H9.015ZM4 6.5C3.72 6.5 3.5 6.275 3.5 6C3.5 5.725 3.72 5.5 4 5.5C4.275 5.5 4.5 5.725 4.5 6C4.5 6.275 4.28 6.5 4 6.5ZM6 6.5C5.72 6.5 5.5 6.275 5.5 6C5.5 5.725 5.72 5.5 6 5.5C6.275 5.5 6.5 5.725 6.5 6C6.5 6.275 6.28 6.5 6 6.5Z'
      fill='#8F8F8F'
    />
    <g clipPath='url(#clip0_4123_207222)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.2109 1.2109C8.49211 0.929699 8.94803 0.929699 9.22923 1.2109L9.75 1.73167L10.2708 1.2109C10.552 0.929699 11.0079 0.929699 11.2891 1.2109C11.5703 1.49211 11.5703 1.94803 11.2891 2.22923L10.7683 2.75L11.2891 3.27077C11.5703 3.55197 11.5703 4.00789 11.2891 4.2891C11.0079 4.5703 10.552 4.5703 10.2708 4.2891L9.75 3.76833L9.22923 4.2891C8.94803 4.5703 8.49211 4.5703 8.2109 4.2891C7.9297 4.00789 7.9297 3.55197 8.2109 3.27077L8.73167 2.75L8.2109 2.22923C7.9297 1.94803 7.9297 1.49211 8.2109 1.2109ZM8.52706 1.91307L8.59691 1.84322L8.52706 1.91307Z'
        fill='#8F8F8F'
      />
    </g>
    <defs>
      <clipPath id='clip0_4123_207222'>
        <rect
          width='3.5'
          height='3.5'
          fill='white'
          transform='translate(8 1)'
        />
      </clipPath>
    </defs>
  </svg>
)

const OfflineIcon = () => (
  <svg
    width='12'
    height='13'
    viewBox='0 0 12 13'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M2.80123 6.87364L2.80123 6.87364L2.80264 6.87255C4.74545 5.37326 7.24973 5.37311 9.19266 6.87209C9.29913 6.95546 9.42276 6.99422 9.54545 6.99422C9.71455 6.99422 9.88876 6.92109 9.99662 6.76778C10.1902 6.51637 10.1448 6.15773 9.8922 5.96554C7.53011 4.13518 4.46481 4.13555 2.0981 5.96601L2.09809 5.96601L2.09733 5.96661C1.84964 6.16011 1.80623 6.51945 1.99604 6.76999L1.99602 6.77L1.99785 6.77235C2.19135 7.02003 2.55068 7.06344 2.80123 6.87364Z'
      fill='#8F8F8F'
      stroke='#8F8F8F'
      strokeWidth='0.4'
    />
    <path
      d='M1.35078 5.13364L1.35078 5.13365L1.35239 5.1324C4.17507 2.94836 7.81919 2.94808 10.6472 5.13204C10.7536 5.21545 10.8773 5.25422 11 5.25422C11.1653 5.25422 11.3421 5.18049 11.4541 5.03046C11.6501 4.77888 11.6052 4.41828 11.3516 4.22543C8.10001 1.71557 3.89524 1.71541 0.648446 4.2254C0.395539 4.41768 0.348007 4.78529 0.548571 5.03384C0.742348 5.2802 1.10074 5.32306 1.35078 5.13364Z'
      fill='#8F8F8F'
      stroke='#8F8F8F'
      strokeWidth='0.4'
    />
    <path
      d='M3.74556 8.70004L3.74557 8.70005L3.74697 8.69897C5.11993 7.63955 6.8841 7.63968 8.25182 8.69835C8.35833 8.78182 8.48203 8.82063 8.60479 8.82063C8.77302 8.82063 8.94361 8.74471 9.05387 8.59688C9.24989 8.3453 9.20502 7.98471 8.95142 7.79186C7.15947 6.4067 4.83426 6.40688 3.04245 7.79241L3.04245 7.79241L3.04166 7.79302C2.79398 7.98652 2.75057 8.34586 2.94037 8.5964L2.94035 8.59641L2.94219 8.59875C3.13569 8.84643 3.49502 8.88985 3.74556 8.70004Z'
      fill='#8F8F8F'
      stroke='#8F8F8F'
      strokeWidth='0.4'
    />
    <path
      d='M5.0473 10.5282C5.62499 10.0793 6.36877 10.0793 6.94653 10.5279C7.05306 10.6114 7.1768 10.6502 7.2996 10.6502C7.47467 10.6502 7.6448 10.5679 7.7492 10.4258C7.9446 10.1743 7.8996 9.81419 7.64627 9.6215C6.64429 8.84628 5.34399 8.84648 4.34216 9.62209L4.34216 9.62209L4.34147 9.62263C4.09379 9.81613 4.05037 10.1755 4.24018 10.426L4.24016 10.426L4.24199 10.4284C4.43549 10.676 4.79483 10.7195 5.04537 10.5297L5.04538 10.5297L5.0473 10.5282Z'
      fill='#8F8F8F'
      stroke='#8F8F8F'
      strokeWidth='0.4'
    />
    <path
      d='M10.2687 1.54374L10.2687 1.54376L1.04374 10.7737C0.85469 10.9628 0.85469 11.2711 1.04374 11.4602L1.0437 11.4602L1.04622 11.4626C1.1382 11.5484 1.25709 11.5995 1.38445 11.5995C1.51224 11.5995 1.63233 11.548 1.72516 11.4552L10.954 2.22631C10.9542 2.2261 10.9544 2.2259 10.9546 2.22569C11.1494 2.03653 11.1494 1.7323 10.9546 1.54316C10.7655 1.35469 10.4576 1.35488 10.2687 1.54374Z'
      fill='#8F8F8F'
      stroke='#8F8F8F'
      strokeWidth='0.2'
    />
  </svg>
)

const formatState = (state: string | null) => {
  if (!state) {
    return ''
  }

  const formatted = state.toLowerCase()
  return formatted.charAt(0).toUpperCase() + formatted.slice(1)
}

type AvatarAreaProps = {
  conversation: any
}

const AvatarArea: React.FC<AvatarAreaProps> = ({ conversation }) => {
  const { allUsers, loadUser } = useUserAPI()
  const {
    api: { closeSession }
  } = useSocket()

  const { owner_id, state } = conversation

  const user = React.useMemo(() => {
    return allUsers[owner_id] ?? null
  }, [allUsers, owner_id])

  const [timeSinceLast, setTimeSinceLast] = React.useState('')
  // Updates time since every 5 seconds
  const updateTimeSince = React.useCallback(() => {
    const latestDate = getLatestEventDate(conversation)
    setTimeSinceLast(formatTimeSince(latestDate))
  }, [conversation])
  useInterval(1000 * 5, updateTimeSince)

  const StateIcon = React.useMemo(() => {
    switch (state) {
      case 'ACTIVE':
        return Message
      case 'OFFLINE':
        return OfflineIcon
      case 'OVERDUE':
        return Timer1
      case 'IDLE':
        return Timer
      case 'ENDED':
        return EndedIcon
      case 'REJECTED':
        return CloseCircle
      default:
        return TickCircle
    }
  }, [state])

  React.useEffect(() => {
    if (!user) {
      loadUser(owner_id)
    }
  }, [user, loadUser, owner_id])

  const classes = useStyles({ state })

  const handleCloseSession = React.useCallback(() => {
    closeSession(conversation.session)
  }, [closeSession, conversation.session])

  return (
    <div className={classes.root}>
      <MediaAvatar user={user} showBadge group />

      <div className={classes.nameArea}>
        <div className={classes.nameRow}>
          <OverflowText className={classes.name}>
            {user?.name ?? 'Loading...'}
          </OverflowText>

          {state === 'ENDED' && (
            <CloseCircle
              size='16'
              variant='Bold'
              color='#8F8F8F'
              onClick={e => {
                e.stopPropagation()
                handleCloseSession()
              }}
              className={classes.closeButton}
            />
          )}
        </div>

        <div className={classes.timeArea}>
          <div className={classes.stateArea}>
            <div>{formatState(state)}</div>

            <div className={classes.icon}>
              <StateIcon size='12' variant='Bold' />
            </div>

            <div className={classes.dot}>&middot;</div>
          </div>

          <div className={classes.time}>{timeSinceLast}</div>
        </div>
      </div>
    </div>
  )
}

export default AvatarArea
